import { twMerge } from 'tailwind-merge';

import type { SkeletonBlockProps } from './SkeletonBlock.types';

export function SkeletonBlock(props: SkeletonBlockProps) {
  const { className, variant = 'foreground' } = props;

  const backgroundClassName =
    variant === 'foreground'
      ? 'bg-pmw-surface-foreground-light dark:bg-pmw-surface-foreground-dark'
      : 'bg-pmw-surface-foreground-sunked-light dark:bg-pmw-surface-foreground-sunked-dark';

  return <div className={twMerge('rounded-[8px]', backgroundClassName, className)} />;
}
